export default __webpack_public_path__ + "static/media/relegation.f950339b.webp";